<template>
<div>
  <div class="overlay">
    <!-- <div class="top-text">
      <div class="wip-text">Work In Progress!</div>
    </div> -->
    <div class="employee" :disabled="!ifTeamleaderAnchorPermission">
    <tl-header type="h3" class="title">
            Headcount
    </tl-header>
    <div>
      <div class="month">
        <img
          src="@/assets/path-2-copy.png"
        />
        <span class="green-text">December 2019</span>
        <img
          src="@/assets/next-icon.png"
        />
      </div>
      <div class="row">
          <div class="empDetails col-12">
            <div class="col-3">
              <canvas id="chart-area"></canvas>
            </div>
            <div class="divider"></div>
            <div class="col-9">
              <div class="flex-column">
                <div class="flex-row">
                  <div class="flex-row">{{ employeeJoinees }} Joinees</div>
                  <div class="flex-row">{{ employeeExits }} Exits</div>
                  <div class="flex-row"><div class="circle green"></div>Joinees</div>
                  <div class="flex-row"><div class="circle blue"></div>Exits</div>
                </div>
                <canvas id="myChart" width="400" height="400"></canvas>
              </div>
            </div>
          </div>
        </div>
    </div>

  </div>
</div>
</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
    name: "EmployeePayroll",
    data() {
        return {
            month: null,
            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            employeeJoinees: 0,
            employeeExits: 0,
            maleCount: 0,
            femaleCount: 0,
            othersCount: 0,
            joineeWeek1: 0,
            joineeWeek2: 0,
            joineeWeek3: 0,
            joineeWeek4: 0,
            joineeWeek5: 0,
            exitsWeek1: 0,
            exitsWeek2: 0,
            exitsWeek3: 0,
            exitsWeek4: 0,
            exitsWeek5: 0,
            chartColors: {
            	red: 'rgb(255, 99, 132)',
            	orange: 'rgb(255, 159, 64)',
            	yellow: 'rgb(255, 205, 86)',
            	green: 'rgb(75, 192, 192)',
            	blue: 'rgb(54, 162, 235)',
            	purple: 'rgb(153, 102, 255)',
            	grey: 'rgb(201, 203, 207)'
            },
            payrollDashboardsValue: false,
            role: ""
        }
    },
    computed: {
      ...mapGetters({
        getleid: "onboard/legal_entities/legal_entity_ID"
      }),
      le_id() {
        if (this.$route.params.entity_index) {
          return this.getleid(this.$route.params.entity_index);
        }
        return this.getleid(0);
      },
      ...mapState("onboard/organization", {
        orgIds: state => state.id,
      }),
      ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.payrollDashboardsValue) {
          return true;
          } else {
            return false;
          }
        } 
        // else {
        // return true 
        // }
        // if(this.payrollDashboardsValue) {
        //   return true;
        // }
      }
    },
    mounted() {
      this.getEmployeeHeadCount();
      this.setChartData();
      this.getOrgLeIdList();
    },
    methods: {
      ...mapActions({
        act_getHeadCount: 'dashboard/payroll/monthlypayroll/headCount/fetchAll'
      }),

      ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
      }),

      async getEmployeeHeadCount() {
        try {
          //console.log("getEmployeeHeadCount");
          let obj = {
            'le_id': this.le_id,
            'month': 3,
            'year': 2019
          };
          let response = await this.act_getHeadCount(obj);
          let resData = response.data.payload;
          //console.log({resData});
          this.maleCount = resData.male;
          this.femaleCount = resData.female;
          this.othersCount = resData.other;
          this.employeeJoinees = resData.newJoinees;
          this.employeeExits = resData.exits;
          this.joineeWeek1 =  resData.joinWeek1;
          this.joineeWeek2 =  resData.joinWeek2;
          this.joineeWeek3 =  resData.joinWeek3;
          this.joineeWeek4 =  resData.joinWeek4;
          this.joineeWeek5 =  resData.joinWeek5;
          this.exitsWeek1 =  resData.exitWeek1;
          this.exitsWeek2 =  resData.exitWeek2;
          this.exitsWeek3 =  resData.exitWeek3;
          this.exitsWeek4 =  resData.exitWeek4;
          this.exitsWeek5 =  resData.exitWeek5;
          this.createDoughnutChart();
        } catch (err) {
          this.toast = true;
          this.errmsg = err;
        }
      },

      randomScalingFactor() {
        return Math.round(Math.random() * 100);
      },

      setChartData() {
        let ctx = document.getElementById('myChart').getContext('2d');
        let barChartData = {
          labels: ['Week1', 'Week2', 'Week3', 'Week4'],
          datasets: [{
            type: 'bar',
            barThickness: 30,
            maxBarThickness: 40,
            order: 0,
            label: 'Joinees',
            id: "y-axis-0",
            backgroundColor: "#34c0be",
            data: [ this.joineeWeek1, this.joineeWeek2, this.joineeWeek3, this.joineeWeek4 ]
          }, {
            type: 'bar',
            barThickness: 30,
            maxBarThickness: 40,
            order: 1,
            label: 'Exits',
            id: "y-axis-1",
            backgroundColor: "#466fcb",
            data: [ this.exitsWeek1, this.exitsWeek2, this.exitsWeek3, this.exitsWeek4 ]
          }]
        };
        let myChart = new Chart(ctx, {
            type: 'verticalBar',
            data: barChartData,
            options: {
              tooltips: {
                mode: 'label'
              },
              responsive: true,
              scales: {
                xAxes: [{
                  stacked: false,
                  offset: true
                }],
                yAxes: [{
                  stacked: false,
                  // offset: true,
                  // position: "left",
                  id: "y-axis-0",
                },
                // {
                //   stacked: false,
                //   position: "right",
                //   id: "y-axis-1",
                // }
              ]
              }
            }
            // options: {
            //   scales: {
            //       yAxes: [{
            //         id: "y-axis-0",
            //         type: 'linear',
            //         position: 'left',
            //       }, {
            //         id: "y-axis-1",
            //         type: 'linear',
            //         position: 'right'
            //         // ticks: {
            //         //   max: 1,
            //         //   min: 0
            //         // }
            //       }]
            //     }
            //
            //     // scales: {
            //     //     yAxes: [{
            //     //         ticks: {
            //     //             beginAtZero: true
            //     //         }
            //     //     }]
            //     // }
            // }
        });
      },

      createDoughnutChart() {
    		let config = {
    			type: 'doughnut',
    			data: {
    				datasets: [{
    					data: [
    						this.maleCount,
    						this.femaleCount,
    						this.othersCount,
    					],
    					backgroundColor: [
    						this.chartColors.red,
    						this.chartColors.yellow,
    						this.chartColors.blue,
    					],
    					label: 'Dataset 1'
    				}],
    				labels: [
    					'Male',
    					'Female',
    					'Others'
    				]
    			},
    			options: {
    				responsive: true,
            plugins: {
    					legend: {
    						position: 'bottom',
    					}
            }
    			}
    		};

      	let ctx = document.getElementById('chart-area').getContext('2d');
      	let doughnutChart = new Chart(ctx, config);
        },

      async getOrgLeIdList() {
        const org = this.orgIds;
        const le = this.le_id;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.payrollDashboardsValue = data.data.user.permissions.payroll_dashboards ? true : false;
        //console.log("PL-3406",data);
      }
    }
}
</script>

<style lang="scss" scoped>
.title{
  padding: 20px;
}
.empDetails {
    display: flex;
    justify-content: center;
    height: 400px;
    max-height: 360px;
    span {
        font-size: 16px;
        color: #606060;
        margin-right: 50px;
        margin-top: 15px;
    }
}
.overlay {
  position: relative;
}

.top-text {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 100%;
  z-index: 1;
}
.wip-text {
  font-family: Montserrat;
  font-size: 32px;
  font-weight: 600;
  text-align: center;
  color: #444444;
  margin-top: 30%;
  transform: rotate(-45deg);
}
.month {
  padding: 10px 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  *:nth-child(n) {
    margin-right: 10px;
  }
}
.employee {
  position: relative;
}
.divider {
  height: auto;
  border-left: 1px solid #eeeeee;
}
.green-text {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  color: #34c0be;
}
.flex-column {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.flex-row {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.circle {
  width: 16px;
  height: 11px;
  margin: 2px 7px 2px 0;
  border-radius: 5.5px;
  &.green {
    background-color: #34c0be;
  }
  &.blue {
    background-color: #466fcb;
  }
}
#myChart{
  max-height:  360px;
  // max-width: 800px;
}
</style>
